import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  plannerFieldFragment,
  evidenceResponseFeedPostFragment,
} from "UnitPlans/modules/UnitPlanFragments";
import {
  getStaffListQuery,
  getUnitPlanQuery,
  getUnitSummaryPlanQuery,
  getCourseStaffGroupQuery,
} from "./IBQuery";
import { unitPlanFragment, staffUnitPlanFragment } from "./IBFragments";
import ACLStore from "lib/aclStore";

export const getStaffCollaborator = staff_id => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Staff:${staff_id}`,
      fragment: staffUnitPlanFragment.staffCourses,
      fragmentName: "staffCoursesItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getUnitPlanDetailsFromCache = ({
  unitPlanId,
  centralRepoInput,
  fields,
  responseFilter,
  collaboratorsFilter,
  libraryBannerFilters,
  exceptionalCollaboratorsFilter,
}) => {
  let queryData = {};
  const skipTitle = ACLStore.can(
    "FeatureFlag:RemoveCourseDetailsFromStaffList"
  );
  try {
    queryData = client.readQuery({
      query: getUnitPlanQuery,
      variables: {
        id: unitPlanId,
        centralRepoInput,
        fields,
        responseFilter,
        collaboratorsFilter,
        exceptionalCollaboratorsFilter,
        skipTitle,
        ...(libraryBannerFilters ? { libraryBannerFilters } : {}),
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getUnitSummaryPlanDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUnitSummaryPlanQuery,
      variables,
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getUnitPlanCollaboratorsFromCache = ({
  unitPlanId,
  variables,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `UnitPlan:${unitPlanId}`,
      fragment: unitPlanFragment.unitPlanCollaborator,
      fragmentName: "unitPlanItem",
      variables,
    });
  } catch (e) {
    // console.log(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "collaborators.edges", []);
  else return {};
};

export const getUnitPlanFieldFromCache = ({ fieldId, responseFilter }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `PlannerField:${fieldId}`,
      fragment: plannerFieldFragment.unitPlanFieldWithResponseFilter,
      fragmentName: "unitPlanFieldItemWithResponseFilter",
      variables: {
        responseFilter,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getPostDetailFromCache = postId => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Post:${postId}`,
      fragment: evidenceResponseFeedPostFragment.postEvidence,
      fragmentName: "postItem",
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeUnitPlanFieldFragment = ({
  fieldId,
  data,
  responseFilter,
}) => {
  client.writeFragment({
    id: `PlannerField:${fieldId}`,
    fragment: plannerFieldFragment.unitPlanFieldWithResponseFilter,
    fragmentName: "unitPlanFieldItemWithResponseFilter",
    data: data,
    variables: {
      responseFilter,
    },
  });
};

export const writeUnitPlanFragment = ({
  unitPlanId,
  data,
  centralRepoInput,
  responseFilter,
  collaboratorsFilter,
  exceptionalCollaboratorsFilter,
}) => {
  const skipTitle = ACLStore.can(
    "FeatureFlag:RemoveCourseDetailsFromStaffList"
  );

  client.writeFragment({
    id: `UnitPlan:${unitPlanId}`,
    fragment: unitPlanFragment.unitPlanDetails,
    fragmentName: "unitPlanItem",
    data: data,
    variables: {
      responseFilter,
      centralRepoInput,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter,
      skipTitle,
    },
  });
};

export const getStaffListFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStaffListQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getCourseStaffGroupFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseStaffGroupQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};
